export default __webpack_public_path__ + "static/media/icon_bp.777cc372.png";